export default "__VITE_ASSET__0a38faae__"